var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('b-breadcrumb', {
    staticClass: "m-0"
  }, [_c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'DashboardHome'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  })]), _c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'GuardGroups'
      }
    }
  }, [_vm._v("群組保護")]), _c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'GroupProtectGuards'
      }
    }
  }, [_vm._v("衛兵狀態列表")]), _c('b-breadcrumb-item', {
    attrs: {
      "active": ""
    }
  }, [_vm._v("衛兵明細資料")])], 1)], 1)])]), _c('b-card', [_c('h4', {
    staticClass: "font-weight-bold"
  }, [_vm._v("衛兵明細資料")]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_vm._v(" 姓名：" + _vm._s(_vm.customer.display_name) + " "), _c('br'), _vm._v(" " + _vm._s(_vm.customer.display_status) + " ")]), _c('div', {
    staticClass: "col-6"
  }, [_vm._v("ID：" + _vm._s(_vm.customer.id))])]), _c('hr'), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-3"
  }, [_c('b-img-lazy', {
    attrs: {
      "src": _vm.customer.avatar_url,
      "fluid": ""
    }
  })], 1), _c('div', {
    staticClass: "col-6"
  }, [_c('div', [_vm._v("外部ID：" + _vm._s(_vm.customer.outer_code))]), _c('div', [_vm._v("手機：" + _vm._s(_vm.customer.mobile_phone))]), _c('div', [_vm._v("E-mail：" + _vm._s(_vm.customer.email))]), _c('div', [_vm._v("生日：" + _vm._s(_vm.customer.birthday && _vm.format(new Date(_vm.customer.birthday), "yyyy-MM-dd HH:mm")))]), _c('div', [_vm._v("性別：" + _vm._s(_vm.customer.sexual))]), _c('div', [_vm._v("好友：" + _vm._s(_vm.customer.is_friend ? "是" : "否"))]), _c('div', [_vm._v("加入時間：" + _vm._s(_vm.customer.join_datetime && _vm.format(new Date(_vm.customer.join_datetime), "yyyy-MM-dd HH:mm")))]), _vm.customer.leave_datetime ? _c('div', [_vm._v(" 離開時間：" + _vm._s(_vm.customer.leave_datetime && _vm.format(new Date(_vm.customer.leave_datetime), "yyyy-MM-dd HH:mm")) + " ")]) : _vm._e(), _c('div', [_vm._v("建立時間：" + _vm._s(_vm.customer.created_at && _vm.format(new Date(_vm.customer.created_at), "yyyy-MM-dd HH:mm")))]), _c('div', [_vm._v("更新時間：" + _vm._s(_vm.customer.updated_at && _vm.format(new Date(_vm.customer.updated_at), "yyyy-MM-dd HH:mm")))])])]), _c('hr'), _c('div', {
    staticClass: "d-flex justify-content-between"
  }, [_c('h4', {
    staticClass: "font-weight-bold"
  }, [_vm._v("所屬群組")]), _c('div', {
    staticClass: "\n          col-12 col-xl-6\n          d-flex\n          flex-column flex-xl-row\n          align-items-start align-items-xl-center\n        "
  }, [_c('b-input-group', {
    staticClass: "ml-0 ml-xl-4"
  }, [_c('b-form-input', {
    attrs: {
      "placeholder": "搜尋群組"
    },
    on: {
      "keyup": function keyup($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.fetchGroups();
      }
    },
    model: {
      value: _vm.keyword,
      callback: function callback($$v) {
        _vm.keyword = $$v;
      },
      expression: "keyword"
    }
  }), _c('b-input-group-append', [_c('b-button', {
    on: {
      "click": function click($event) {
        return _vm.fetchGroups();
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])], 1)], 1)], 1)]), _c('b-table', {
    attrs: {
      "responsive": "",
      "striped": "",
      "hover": "",
      "items": _vm.groups,
      "fields": _vm.fields
    },
    scopedSlots: _vm._u([{
      key: "cell(name)",
      fn: function fn(data) {
        return [_c('div', {
          staticClass: "mb-1"
        }, [_vm._v(" " + _vm._s(data.item.name) + " ")]), _c('div', [_vm._v(" " + _vm._s(data.item.group_number) + " ")])];
      }
    }, {
      key: "cell(picture_url)",
      fn: function fn(data) {
        return [_c('b-img-lazy', _vm._b({
          directives: [{
            name: "show",
            rawName: "v-show",
            value: !!data.item.picture_url,
            expression: "!!data.item.picture_url"
          }],
          attrs: {
            "rounded": "",
            "src": data.item.picture_url
          }
        }, 'b-img-lazy', _vm.mainProps, false))];
      }
    }, {
      key: "cell(status)",
      fn: function fn(data) {
        return [_c('i', {
          class: "fa fa-circle h2 text-".concat(_vm.statusEnum(data.item.status))
        })];
      }
    }, {
      key: "cell(actions)",
      fn: function fn(data) {
        return [_c('b-button', {
          staticClass: "ml-2",
          attrs: {
            "variant": data.item.status == 0 ? "primary" : "danger",
            "size": "md"
          }
        }, [_vm._v(" " + _vm._s(data.item.status == 0 ? "\u8A2D\u5B9A" : "\u91CD\u8A2D"))])];
      }
    }])
  })], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }